import { render, staticRenderFns } from "./FormSubTitle.vue?vue&type=template&id=03e7fdea&functional=true"
var script = {}
import style0 from "./FormSubTitle.vue?vue&type=style&index=0&id=03e7fdea&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports